import { render, staticRenderFns } from "./pogs-form--role.vue?vue&type=template&id=9e24f3d0&"
import script from "./pogs-form--role.vue?vue&type=script&lang=js&"
export * from "./pogs-form--role.vue?vue&type=script&lang=js&"
import style0 from "./pogs-form--role.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports